<template>
    <div class="ConfirmModal" :class="type">
        <div class="main">
            <div class="header">
                <h1>{{ title }}</h1>

                <div
                    v-if="type === 'delete'"
                    class="alert"
                >
                    <div class="alertIcon">
                        <Icon name="exclamation"/>
                    </div>
                    <span>This action cannot be undone!</span>
                </div>
                <div
                    v-else-if="type === 'warning' && warningMessage"
                    class="alert"
                >
                    <div class="alertIcon">
                        <Icon name="exclamation"/>
                    </div>
                    <span>{{ warningMessage }}</span>
                </div>
            </div>

            <p>{{ message }}</p>
        </div>

        <div class="actions">
            <Button class="link muted" @click="handleCancel">{{ cancelLabel }}</Button>
            <Button class="primary" @click="handleConfirm">{{ confirmLabel }}</Button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ConfirmModal',

    props: {
        type: { type: String, default: 'confirm' },
        title: { type: String, default: 'Are you sure?' },
        message: { type: String, default: '' },
        warningMessage: { type: String, default: '' },
        onConfirm: { type: Function, default: () => {} },
        confirmLabel: { type: String, default: 'Confirm' },
        cancelLabel: { type: String, default: 'Cancel' },
    },

    methods: {
        handleConfirm() {
            this.$emit('close');
            this.onConfirm();
        },

        handleCancel() {
            this.$emit('close');
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.ConfirmModal {
    @extend %modal;

    .header {
        margin-bottom: 15px;
    }

    p {
        @extend %display-description;
    }

    .actions {
        display: flex;
        justify-content: flex-end;
        margin-top: 30px;
    }

    .alert {
        display: flex;
        align-items: center;
        margin-top: 10px;
        border-radius: $border-radius;
        overflow: hidden;
        background-color: rgba($yellow-color, 0.3);

        .alertIcon {
            padding: 10px 15px;
            display: flex;
            align-items: center;
            background-color: $yellow-color;
            color: #fff;
        }

        span {
            padding: 0 10px;
        }
    }

    &.delete .Button.primary {
        background-color: $red-color;
    }

    &.warning .Button.primary {
        background-color: darken($yellow-color, 10%);
    }
}
</style>
